<div
  style="
    min-width: 220px;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  "
>
  @if (dialogRef && esDialog) {
    <div>
      <mat-card style="border: 1px solid black; overflow-x: hidden">
        <mat-card-header style="border-radius: 2px 2px 0 0">
          <mat-card-title
            cdkDrag
            cdkDragHandle
            cdkDragRootElement=".cdk-overlay-pane"
            [cdkDragBoundary]="dragBoundary"
            (cdkDragStarted)="bringToFront()"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <span style="padding-left: 8px">
              {{ camara?.identificacion }}
            </span>
            <button
              irxBotonIcono
              tamano="compacto"
              tooltip="Cerrar"
              (click)="closeDialog()"
            >
              <mat-icon>close</mat-icon>
            </button>
          </mat-card-title>
        </mat-card-header>

        <mat-card-content
          style="
            margin: 1em 0;
            overflow: auto;
            justify-content: center;
            display: flex;
            overflow-x: hidden;
          "
        >
          <div>
            <mat-divider></mat-divider>
            <div
              style="
                display: flex;
                flex-direction: row;
                gap: 0.5em;
                margin-top: 1em;
              "
            >
              @if (camara) {
                <app-camera-player
                  [idCamara]="camara._id"
                  [canal]="canal"
                  [fecha]="fecha"
                  [mainStream]="mainStream"
                  [encryptionKey]="camara.claveDeEncriptacion"
                  [botonMultiple]="botonMultiple"
                  [maximizado]="maximizado"
                  (maximizadoEmiter)="botonClick()"
                ></app-camera-player>
              }
            </div>
          </div>
        </mat-card-content>

        <mat-dialog-actions
          style="
            display: flex;
            justify-content: space-between;
            padding: 6px;
            gap: 8px;
          "
        ></mat-dialog-actions>
      </mat-card>
    </div>
  } @else {
    @if (camara) {
      <app-camera-player
        [idCamara]="camara._id"
        [canal]="canal"
        [fecha]="fecha"
        [mainStream]="mainStream"
        [encryptionKey]="camara.claveDeEncriptacion"
        [botonMultiple]="botonMultiple"
        [maximizado]="maximizado"
        (maximizadoEmiter)="botonClick()"
      ></app-camera-player>
    }
  }
</div>
